import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SvgIcon from './base/SvgIcon.vue';
import { useRoomStore } from '../../stores/room';
import { storeToRefs } from 'pinia';
import { isUndefined } from '../../utils/utils';
import MicOnIcon from './icons/MicOnIcon.vue';
import MicOffIcon from './icons/MicOffIcon.vue';

interface Props {
  userId?: string,
  audioVolume?: number,
  isMuted?: boolean,
  size?: string,
  isDisabled?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioIcon',
  props: {
    userId: null,
    audioVolume: null,
    isMuted: { type: Boolean },
    size: null,
    isDisabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  userId?: string,
  audioVolume?: number,
  isMuted?: boolean,
  size?: string,
  isDisabled?: boolean,
}

const roomStore = useRoomStore();
const { userVolumeObj } = storeToRefs(roomStore);

const currentAudioVolume = computed(() => {
  if (!isUndefined(props.audioVolume)) {
    return props.audioVolume;
  }
  if (userVolumeObj.value && props.userId) {
    return userVolumeObj.value[props.userId];
  }
  return 0;
});



const icon = computed(() => (props.isMuted ? MicOffIcon : MicOnIcon));

const audioLevelStyle = computed(() => {
  if (props.isMuted || !currentAudioVolume.value) {
    return '';
  }
  return `height: ${currentAudioVolume.value * 4}%`;
});


return { __sfc: true,roomStore, userVolumeObj, currentAudioVolume, props, icon, audioLevelStyle, SvgIcon }
}

})